import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import Selectable, { SelectEventListener } from '@philips-emr/tws-core/lib/component/types/selectable';
import { isObject } from '@philips-emr/tws-utils';

export type DataItem = Record<string, Record<string, Value>>;
export type SelectedGroup = Record<string, DataItem[]>;
export type Selected = DataItem[] | SelectedGroup;

function isValidSelected(value: Selected): boolean {
  if (isObject(value)) {
    const castedValue = value as SelectedGroup;
    return Object.values(castedValue).every((value) => Array.isArray(value));
  }

  return Array.isArray(value);
}

class SelectableIteratorAPI extends ComponentAPI implements Selectable<Record<string, Value>> {
  /** @event */
  @AwesomeEvent
  onSelect = new SelectEventListener<Record<string, Value>>();

  getData(): DataItem[] {
    return this.state.data;
  }

  setData(data: DataItem[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }

    throw new Error('The informed value is not valid.');
  }

  isMultiSelect(): boolean {
    return this.state.multiselect;
  }

  getPrimaryKey(): string {
    return this.state.primaryKey;
  }

  setPrimaryKey(primaryKey: string): void {
    this.setState({ primaryKey });
  }

  getSelected(): Selected {
    return this.state.selected;
  }

  setSelected(selected: Selected): void {
    if (isValidSelected(selected)) {
      this.setState({ selected });
    }

    throw new Error(
      'The informed value is not valid. Please check the Selected type.'
    );
  }
}

export default SelectableIteratorAPI;
